/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';
import ShippingMapLegend from './shipping-map-legend';
import ShippingMapList from './shipping-map-list';
import ShippingMapSvg from './shipping-map-svg';
import { IShippingMapData } from './shipping-map.data';
import { IShippingMapProps } from './shipping-map.props.autogenerated';

// ==============================================================================
/**
 * ShippingMap component
 * @extends {React.PureComponent<IShippingMapProps<IShippingMapData>>}
 */
// ==============================================================================
class ShippingMap extends React.PureComponent<IShippingMapProps<IShippingMapData>> {

    // ------------------------------------------------------
    // ------------------------------------------------------
    public constructor(props: IShippingMapProps<IShippingMapData>) {
        super(props);
        this._findActiveState = this._findActiveState.bind(this);
    }

    // ------------------------------------------------------
    // ------------------------------------------------------
    public render(): JSX.Element {
        const { config } = this.props;

        return (
            <div className='shipping-map'>
                <ShippingMapSvg findActiveState={this._findActiveState} />
                {config && config.showLegend && <ShippingMapLegend config={config} />}
                {config && config.showList && <ShippingMapList statesSettings={this.props.app.config.statesSettings}/>}
            </div>
        );
    }

    // ------------------------------------------------------
    // ------------------------------------------------------
    private _findActiveState(state: string): boolean {
        return this.props.app.config && this.props.app.config.statesSettings && this.props.app.config.statesSettings[state]
        ? true
        : false;
    }
}

export default ShippingMap;